/* eslint-disable */
export default {
  forward: '転送',
  cancel: 'キャンセル',
  customNumber: 'カスタム番号',
} as const;

// @key: @#@"forward"@#@ @source: @#@"Forward"@#@
// @key: @#@"cancel"@#@ @source: @#@"Cancel"@#@
// @key: @#@"customNumber"@#@ @source: @#@"Custom number"@#@
